<template>
  <div class="courses" id="course-section" ref="courses" :class="{ selected: selectedLanguage }">
    <div v-if="selectedLanguage">
      <div class="section section__first">
        <h3 class="section-title section-title--mobile">1 na 1</h3>
        <div class="section-text">
          <h3 class="section-title section-title--desktop">1 na 1</h3>
          <p>
            Uči gdje god želiš — bez odlaska u školu, prema rasporedu koji ti odgovara, uz profesora koji te vodi i motivira. 
            Sve što ti treba su laptop ili mobitel, slušalice i dobra internetska veza. Ne moraš čak ni uključiti kameru!
          </p>
          <div class="course-apply">
            <div class="section-text__important">
              <p><b>KLASIČNI TEČAJ</b></p>
            </div>
            <div class="course-hours">
              <div>
                <p>30 školskih sati</p>
              </div>
            </div>
            <div class="course-price">
              <div>
                <p>599€ (ili na rate 6 x 108 = 648€)</p>
              </div>
            </div>
            <div class="course-info">
              <p>BEZ SKRIVENIH TROŠKOVA: testiranje, knjige, ispit i diploma su uključeni u cijenu</p>
            </div>
          </div>
          <div class="course-apply second">
            <div class="section-text__important">
              <p><b>INTENZIVNI TEČAJ</b></p>
            </div>
            <div class="course-hours">
              <div>
                <p>20 školskih sati</p>
              </div>
            </div>
            <div class="course-price">
              <div>
                <p>449€ (ili na rate 6 x 83 = 498€)</p>
              </div>
            </div>
            <div class="course-info">
              <p>*isti sadržaj se prolazi u manje nastavnih sati (više samostalne vježbe nakon sata)</p>
            </div>
            <div class="course-info">
              <p>BEZ SKRIVENIH TROŠKOVA: testiranje, knjige, ispit i diploma su uključeni u cijenu</p>
            </div>
          </div>
          <router-link :to="{ path: '/prijava', query: { lang: selectedLanguage } }" class="primary-button"
            >Prijavi se
          </router-link>
        </div>
        <div class="section-image">
          <img
            src="@/assets/oneonone.webp"
            alt="Učenje engleskog jezika kod kuće"
            loading="lazy"
          />
        </div>
      </div>

      <div class="section section__second">
        <h3 class="section-title section-title--mobile">U paru</h3>
        <div class="section-image">
          <img
            src="@/assets/pair.webp"
            alt="Učenje engleskog jezika"
            loading="lazy"
          />
        </div>
        <div class="section-text">
          <h3 class="section-title section-title--desktop">U paru</h3>
          <p>
            Muž, brat ili frendica žele naučiti isti jezik kao ti? Podijeli račun i uz dodatnu podršku svog partnera i profesora propričaj 
            jezik koji želiš! Jedini uvjet je da ste na istoj razini predznanja. U dvoje je slađe jer uvijek možeš prepisati zadaću! (Šalimo se, naravno.)
          </p>
          <div class="course-apply">
            <div class="course-hours">
              <div>
                <p>30 školskih sati</p>
              </div>
            </div>
            <div class="course-price">
              <div>
                <p>po osobi: 369€ (ili na rate 5 x 82 = 410€)</p>
              </div>
            </div>
            <div class="course-info">
              <p>BEZ SKRIVENIH TROŠKOVA: testiranje, knjige, ispit i diplome su uključeni u cijenu</p>
            </div>
          </div>
          <router-link :to="{ path: '/prijava', query: { lang: selectedLanguage } }" class="primary-button"
            >Prijavi se
          </router-link>
        </div>
      </div>

      <div 
        class="section section__third" 
        v-if="selectedLanguage === 'en'"
      >
        <h3 class="section-title section-title--mobile">
          Business Spika
        </h3>
        <div class="section-text">
          <h3 class="section-title section-title--desktop">
            Business Spika
          </h3>
          <p>
            Želiš pričati samo o poslovnim temama i vježbati situacije u kojima se možeš naći na radnom mjestu? Nauči korisne riječi i izraze 
            uz Business Spiku! Naši profesori sjajno glume kolege i klijente i ispravit će pogreške koje te sprječavaju da zvučiš jednako pametno na 
            engleskom kao i na hrvatskom.
          </p>
          <div class="course-apply course-apply--company">
            <div class="course-hours">
              <div>
                <p>20 školskih sati</p>
              </div>
            </div>
            <div class="course-price">
              <div>
                <p>497€ (ili na rate 6 x 91 = 546€)</p>
              </div>
            </div>
            <div class="course-info">
              <p>UVJET: predznanje B1 na testiranju ili diploma o položenom B1 stupnju</p>
            </div>
            <div class="course-info">
              <p>BEZ SKRIVENIH TROŠKOVA: testiranje, knjige, ispit i diplome su uključeni u cijenu</p>
            </div>
          </div>
          <router-link :to="{ path: '/prijava', query: { lang: selectedLanguage } }" class="primary-button"
            >Prijavi se
          </router-link>
        </div>
        <div class="section-image">
          <img
            src="@/assets/business.webp"
            alt="Učenje business jezika od kuće"
            loading="lazy"
          />
        </div>
      </div>


      <div class="section section__third" :class="{ reverse: selectedLanguage === 'de' }">
        <div class="section-image section-image--pair">
          <img
            src="@/assets/company.webp"
            alt="Učenje njemačkog jezika kod kuće"
            loading="lazy"
          />
        </div>
        <h3 class="section-title section-title--mobile">
          Firmaši
        </h3>
        <div class="section-text">
          <h3 class="section-title section-title--desktop">
            Firmaši
          </h3>
          <p>
            Tvoja ekipa s posla je najjača, a bila bi još jača da joj idu strani jezici. Obrišite prevoditelj s desktopa 
            i impresionirajte strane klijente! Od A1 njemačkog do C1 engleskog - sve je lako uz ekipu. #pišinafirmu 
          </p>
          <div class="course-apply course-apply--company">
            <div class="course-hours">
              <div>
                <p>30 školskih sati</p>
              </div>
            </div>
            <div class="course-price">
              <div>
                <p>po osobi: 359€ (ili na rate 5 x 81 = 405€)</p>
              </div>
            </div>
            <div class="course-info">
              <p>grupni tečaj  (min. 3 polaznika)</p>
            </div>
            <div class="course-info">
              <p>BEZ SKRIVENIH TROŠKOVA: testiranje, knjige, ispit i diplome su uključeni u cijenu</p>
            </div>
          </div>
          <router-link :to="{ path: '/prijava', query: { lang: selectedLanguage } }" class="primary-button"
            >Prijavi se
          </router-link>
        </div>
      </div>

      <div class="section section__fourth" :class="{ reverse: selectedLanguage === 'de' }">
        <h3 class="section-title section-title--mobile">
          Samo Spika
        </h3>
        <div class="section-text">
          <h3 class="section-title section-title--desktop">
            Samo Spika
          </h3>
          <p>
            Gledaš serije bez titlova, ali kad trebaš pričati — uhvati te panika? Razgovaraj s našim profesorima o raznim temama i 
            budi spreman na baš svaku situaciju! Tijekom razgovora ispravljat ćemo tvoje greške i izgovor, ali te nećemo zamarati 
            pretjeranom gramatikom.Vrijeme će ti proletjeti kao da si na kavi s frendom!
          </p>
          <div class="course-apply">
            <div class="course-hours">
              <div>
                <p>15 školskih sati</p>
              </div>
            </div>
            <div class="course-price">
              <div>
                <p>299€ (ili na rate 5 x 69 = 345€)</p>
              </div>
            </div>
            <div class="course-info">
              <p>konverzacijski tečaj </p>
            </div>
            <div class="course-info">
              <p>digitalni materijali + spika bag </p>
            </div>
            <div class="course-info">
              <p>BEZ SKRIVENIH TROŠKOVA: testiranje, knjige, ispit i diplome su uključeni u cijenu</p>
            </div>
          </div>
          <router-link :to="{ path: '/prijava', query: { lang: selectedLanguage } }" class="primary-button"
            >Prijavi se
          </router-link>
        </div>
        <div class="section-image">
          <img src="@/assets/hellogirl.webp" alt="Učenje njemačkog jezika" loading="lazy"/>
        </div>
      </div>
    </div>

    <div class="language-selection">
      <div 
        class="language-choice language-choice--english" 
        @click="selectLanguage('en')"
      >
        <img src="@/assets/english-flag.webp" alt="english flag">
        <p>Engleski</p>
        <div class="language-background"></div>
      </div>

      <div 
        class="language-choice language-choice--german"
        @click="selectLanguage('de')"
      >
        <img src="@/assets/german-flag.webp" alt="german flag">
        <p>Njemački</p>
        <div class="language-background"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tecajevi",
  data() {
    return {
      selectedLanguage: null,
    };
  },
  methods: {
    scrollDown: function (div) {
      console.log("scroll");
      var element = this.$refs[div];
      var top = element.offsetTop;
      window.scrollTo({
        top: top,
        behavior: "smooth",
      });
    },
    selectLanguage(lang) {
      this.selectedLanguage = lang;
      window.scrollTo(0, 0);
    },
  },
};
</script>
